export default {
  zoneStr: '',
  zoneAry: [],
  prompts: [],
  mapCityName: '',
  fullAddress: '',
  countryName: '',
  coordinate: null,
  exampleAddress: '',
  googleSearchTerm: '',
};
